// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shipping-wizard {
    padding: 0.25rem 0;
}

.shipping-wizard.full-page {
    max-width: 1000px;
}

.shipping-wizard > h2 {
    margin-top: 0;
}

.shipping-prefill-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin: 0 0 1rem;
    padding: 0.85rem 1rem;
    border: 1px solid #c8d9f0;
    border-radius: 8px;
    background: #f3f8ff;
}

.shipping-prefill-banner p {
    margin: 0;
    color: #24364f;
    line-height: 1.35;
}

.shipping-prefill-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
}

.shipping-card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    gap: 0.75rem;
}

.shipping-card-grid.two {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    margin-bottom: 1rem;
}

.shipping-choice-card {
    min-height: 118px;
    padding: 1rem;
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    background: #fff;
    text-align: left;
    cursor: pointer;
}

.shipping-choice-card strong,
.shipping-choice-card span {
    display: block;
}

.shipping-choice-card strong {
    margin-bottom: 0.65rem;
    color: #222;
}

.shipping-choice-card span {
    color: #555;
    line-height: 1.35;
}

.shipping-choice-card.selected {
    border-color: #111;
    box-shadow: 0 0 0 2px #111 inset;
}

.shipping-choice-card.compact {
    min-height: 92px;
}

.shipping-preset-list {
    display: grid;
    gap: 0.45rem;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
}

.shipping-wizard .group button.shipping-preset-option {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.15rem;
    align-items: start;
    border: 1px solid #d4d4d4;
    border-radius: 6px;
    padding: 0.55rem 0.65rem;
    background: #fff;
    color: #222;
    cursor: pointer;
    text-align: left;
}

.shipping-wizard .group button.shipping-preset-option:hover {
    background: #f7f7f7;
    color: #111;
}

.shipping-wizard .group button.shipping-preset-option strong,
.shipping-wizard .group button.shipping-preset-option span {
    display: block;
    min-width: 0;
}

.shipping-wizard .group button.shipping-preset-option strong {
    font-size: 0.9rem;
    line-height: 1.2;
}

.shipping-wizard .group button.shipping-preset-option span {
    color: #555;
    font-size: 0.8rem;
    line-height: 1.25;
    font-weight: 400;
}

.shipping-wizard .group button.shipping-preset-option.selected {
    border-color: #222;
    box-shadow: 0 0 0 1px #222 inset;
}

.shipping-wizard .group button.shipping-preset-option + button.shipping-preset-option {
    margin-left: 0;
}

.shipping-inline-fields {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.shipping-inline-fields input {
    flex: 1;
}

.shipping-inline-fields select {
    width: 90px;
}

.shipping-fieldset {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    margin: 0 0 1rem;
}

.shipping-fieldset legend {
    font-weight: 700;
    color: #444;
    padding: 0 0.25rem;
}

.shipping-fieldset label.checkbox {
    display: block;
    margin: 0.45rem 0;
}

.shipping-fieldset label.checkbox input {
    margin-right: 0.4rem;
}

.shipping-method-detail {
    margin: 0.7rem 0 0.15rem 1.45rem;
    max-width: 520px;
}

.shipping-wizard .group button.shipping-chip {
    display: inline-flex;
    align-items: center;
    width: auto;
    border: 1px solid #bbb;
    border-radius: 999px;
    background: #fff;
    color: #222;
    padding: 0.05rem 0.35rem;
    font-size: 0.78rem;
    line-height: 1.25;
    cursor: pointer;
}

.shipping-wizard .group button.shipping-chip:hover {
    background: #f4f4f4;
    color: #111;
}

.shipping-summary {
    display: grid;
    grid-template-columns: minmax(130px, 0.3fr) 1fr;
    gap: 0.65rem 1rem;
    margin: 1rem 0;
}

.shipping-summary dt {
    font-weight: 700;
    color: #333;
}

.shipping-summary dd {
    margin: 0;
}

.shipping-step-error {
    margin: 1rem 0 0;
}

button.pickup-scheduling-trigger {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    margin-top: 0.6rem;
    padding: 0;
    border: none;
    background: none;
    color: var(--color-link, #1a5fb4);
    cursor: pointer;
    text-decoration: underline;
    font-size: 0.9rem;
}

button.pickup-scheduling-trigger:hover {
    opacity: 0.8;
}

.pickup-scheduling-modal .booking-form-actions {
    margin-top: 1rem;
}

.shipping-examples-table {
    width: 100%;
}

.shipping-examples-table th,
.shipping-examples-table td {
    vertical-align: top;
}

@media (max-width: 600px) {
    .shipping-prefill-banner {
        align-items: stretch;
        flex-direction: column;
    }

    .shipping-prefill-actions {
        justify-content: flex-start;
    }

    .shipping-summary {
        grid-template-columns: 1fr;
    }

    .shipping-summary dt {
        margin-top: 0.5rem;
    }

    .shipping-examples-table,
    .shipping-examples-table thead,
    .shipping-examples-table tbody,
    .shipping-examples-table tr,
    .shipping-examples-table th,
    .shipping-examples-table td {
        display: block;
    }

    .shipping-examples-table thead {
        display: none;
    }

    .shipping-examples-table tr {
        border: 1px solid #ddd;
        border-radius: 6px;
        margin-bottom: 0.75rem;
        padding: 0.35rem 0.5rem;
    }

    .shipping-examples-table td {
        display: flex;
        justify-content: space-between;
        gap: 1rem;
        padding: 0.35rem 0;
    }

    .shipping-examples-table td::before {
        content: attr(data-label);
        color: #555;
        font-weight: 700;
    }
    [data-theme="dark"] .shipping-examples-table tr { border-color: #3a463e; }
    [data-theme="dark"] .shipping-examples-table td::before { color: #9fb0a6; }
}
[data-theme="dark"] .shipping-prefill-banner { border-color: #2d4a63; background: #16232f; }
[data-theme="dark"] .shipping-prefill-banner p { color: #8ec2f5; }
[data-theme="dark"] .shipping-choice-card { border-color: #3a463e; background: #1c2620; }
[data-theme="dark"] .shipping-choice-card strong { color: #e3ece6; }
[data-theme="dark"] .shipping-choice-card span { color: #9fb0a6; }
[data-theme="dark"] .shipping-choice-card.selected { border-color: #e3ece6; box-shadow: 0 0 0 2px #e3ece6 inset; }
[data-theme="dark"] .shipping-wizard .group button.shipping-preset-option { border-color: #3a463e; background: #1c2620; color: #e3ece6; }
[data-theme="dark"] .shipping-wizard .group button.shipping-preset-option:hover { background: #222f28; color: #cfe3d6; }
[data-theme="dark"] .shipping-wizard .group button.shipping-preset-option span { color: #9fb0a6; }
[data-theme="dark"] .shipping-wizard .group button.shipping-preset-option.selected { border-color: #e3ece6; box-shadow: 0 0 0 1px #e3ece6 inset; }
[data-theme="dark"] .shipping-fieldset { border-color: #3a463e; }
[data-theme="dark"] .shipping-fieldset legend { color: #cfe3d6; }
[data-theme="dark"] .shipping-wizard .group button.shipping-chip { border-color: #3a463e; background: #1c2620; color: #e3ece6; }
[data-theme="dark"] .shipping-wizard .group button.shipping-chip:hover { background: #222f28; color: #cfe3d6; }
[data-theme="dark"] .shipping-summary dt { color: #cfe3d6; }
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Shipping/ShippingWizard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,YAAY;AAChB;;AAEA;IACI,2DAA2D;IAC3D,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,2DAA2D;AAC/D;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;;;;QAMI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,gBAAgB;IACpB;IACA,kDAAkD,qBAAqB,EAAE;IACzE,0DAA0D,cAAc,EAAE;AAC9E;AACA,+CAA+C,qBAAqB,EAAE,mBAAmB,EAAE;AAC3F,iDAAiD,cAAc,EAAE;AACjE,4CAA4C,qBAAqB,EAAE,mBAAmB,EAAE;AACxF,mDAAmD,cAAc,EAAE;AACnE,iDAAiD,cAAc,EAAE;AACjE,qDAAqD,qBAAqB,EAAE,mCAAmC,EAAE;AACjH,4EAA4E,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACxI,kFAAkF,mBAAmB,EAAE,cAAc,EAAE;AACvH,iFAAiF,cAAc,EAAE;AACjG,qFAAqF,qBAAqB,EAAE,mCAAmC,EAAE;AACjJ,yCAAyC,qBAAqB,EAAE;AAChE,gDAAgD,cAAc,EAAE;AAChE,mEAAmE,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC/H,yEAAyE,mBAAmB,EAAE,cAAc,EAAE;AAC9G,2CAA2C,cAAc,EAAE","sourcesContent":[".shipping-wizard {\n    padding: 0.25rem 0;\n}\n\n.shipping-wizard.full-page {\n    max-width: 1000px;\n}\n\n.shipping-wizard > h2 {\n    margin-top: 0;\n}\n\n.shipping-prefill-banner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    margin: 0 0 1rem;\n    padding: 0.85rem 1rem;\n    border: 1px solid #c8d9f0;\n    border-radius: 8px;\n    background: #f3f8ff;\n}\n\n.shipping-prefill-banner p {\n    margin: 0;\n    color: #24364f;\n    line-height: 1.35;\n}\n\n.shipping-prefill-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-shrink: 0;\n}\n\n.shipping-card-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n    gap: 0.75rem;\n}\n\n.shipping-card-grid.two {\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    margin-bottom: 1rem;\n}\n\n.shipping-choice-card {\n    min-height: 118px;\n    padding: 1rem;\n    border: 1px solid #d8d8d8;\n    border-radius: 8px;\n    background: #fff;\n    text-align: left;\n    cursor: pointer;\n}\n\n.shipping-choice-card strong,\n.shipping-choice-card span {\n    display: block;\n}\n\n.shipping-choice-card strong {\n    margin-bottom: 0.65rem;\n    color: #222;\n}\n\n.shipping-choice-card span {\n    color: #555;\n    line-height: 1.35;\n}\n\n.shipping-choice-card.selected {\n    border-color: #111;\n    box-shadow: 0 0 0 2px #111 inset;\n}\n\n.shipping-choice-card.compact {\n    min-height: 92px;\n}\n\n.shipping-preset-list {\n    display: grid;\n    gap: 0.45rem;\n    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n}\n\n.shipping-wizard .group button.shipping-preset-option {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.15rem;\n    align-items: start;\n    border: 1px solid #d4d4d4;\n    border-radius: 6px;\n    padding: 0.55rem 0.65rem;\n    background: #fff;\n    color: #222;\n    cursor: pointer;\n    text-align: left;\n}\n\n.shipping-wizard .group button.shipping-preset-option:hover {\n    background: #f7f7f7;\n    color: #111;\n}\n\n.shipping-wizard .group button.shipping-preset-option strong,\n.shipping-wizard .group button.shipping-preset-option span {\n    display: block;\n    min-width: 0;\n}\n\n.shipping-wizard .group button.shipping-preset-option strong {\n    font-size: 0.9rem;\n    line-height: 1.2;\n}\n\n.shipping-wizard .group button.shipping-preset-option span {\n    color: #555;\n    font-size: 0.8rem;\n    line-height: 1.25;\n    font-weight: 400;\n}\n\n.shipping-wizard .group button.shipping-preset-option.selected {\n    border-color: #222;\n    box-shadow: 0 0 0 1px #222 inset;\n}\n\n.shipping-wizard .group button.shipping-preset-option + button.shipping-preset-option {\n    margin-left: 0;\n}\n\n.shipping-inline-fields {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n.shipping-inline-fields input {\n    flex: 1;\n}\n\n.shipping-inline-fields select {\n    width: 90px;\n}\n\n.shipping-fieldset {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 0.75rem 1rem;\n    margin: 0 0 1rem;\n}\n\n.shipping-fieldset legend {\n    font-weight: 700;\n    color: #444;\n    padding: 0 0.25rem;\n}\n\n.shipping-fieldset label.checkbox {\n    display: block;\n    margin: 0.45rem 0;\n}\n\n.shipping-fieldset label.checkbox input {\n    margin-right: 0.4rem;\n}\n\n.shipping-method-detail {\n    margin: 0.7rem 0 0.15rem 1.45rem;\n    max-width: 520px;\n}\n\n.shipping-wizard .group button.shipping-chip {\n    display: inline-flex;\n    align-items: center;\n    width: auto;\n    border: 1px solid #bbb;\n    border-radius: 999px;\n    background: #fff;\n    color: #222;\n    padding: 0.05rem 0.35rem;\n    font-size: 0.78rem;\n    line-height: 1.25;\n    cursor: pointer;\n}\n\n.shipping-wizard .group button.shipping-chip:hover {\n    background: #f4f4f4;\n    color: #111;\n}\n\n.shipping-summary {\n    display: grid;\n    grid-template-columns: minmax(130px, 0.3fr) 1fr;\n    gap: 0.65rem 1rem;\n    margin: 1rem 0;\n}\n\n.shipping-summary dt {\n    font-weight: 700;\n    color: #333;\n}\n\n.shipping-summary dd {\n    margin: 0;\n}\n\n.shipping-step-error {\n    margin: 1rem 0 0;\n}\n\nbutton.pickup-scheduling-trigger {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    margin-top: 0.6rem;\n    padding: 0;\n    border: none;\n    background: none;\n    color: var(--color-link, #1a5fb4);\n    cursor: pointer;\n    text-decoration: underline;\n    font-size: 0.9rem;\n}\n\nbutton.pickup-scheduling-trigger:hover {\n    opacity: 0.8;\n}\n\n.pickup-scheduling-modal .booking-form-actions {\n    margin-top: 1rem;\n}\n\n.shipping-examples-table {\n    width: 100%;\n}\n\n.shipping-examples-table th,\n.shipping-examples-table td {\n    vertical-align: top;\n}\n\n@media (max-width: 600px) {\n    .shipping-prefill-banner {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .shipping-prefill-actions {\n        justify-content: flex-start;\n    }\n\n    .shipping-summary {\n        grid-template-columns: 1fr;\n    }\n\n    .shipping-summary dt {\n        margin-top: 0.5rem;\n    }\n\n    .shipping-examples-table,\n    .shipping-examples-table thead,\n    .shipping-examples-table tbody,\n    .shipping-examples-table tr,\n    .shipping-examples-table th,\n    .shipping-examples-table td {\n        display: block;\n    }\n\n    .shipping-examples-table thead {\n        display: none;\n    }\n\n    .shipping-examples-table tr {\n        border: 1px solid #ddd;\n        border-radius: 6px;\n        margin-bottom: 0.75rem;\n        padding: 0.35rem 0.5rem;\n    }\n\n    .shipping-examples-table td {\n        display: flex;\n        justify-content: space-between;\n        gap: 1rem;\n        padding: 0.35rem 0;\n    }\n\n    .shipping-examples-table td::before {\n        content: attr(data-label);\n        color: #555;\n        font-weight: 700;\n    }\n    [data-theme=\"dark\"] .shipping-examples-table tr { border-color: #3a463e; }\n    [data-theme=\"dark\"] .shipping-examples-table td::before { color: #9fb0a6; }\n}\n[data-theme=\"dark\"] .shipping-prefill-banner { border-color: #2d4a63; background: #16232f; }\n[data-theme=\"dark\"] .shipping-prefill-banner p { color: #8ec2f5; }\n[data-theme=\"dark\"] .shipping-choice-card { border-color: #3a463e; background: #1c2620; }\n[data-theme=\"dark\"] .shipping-choice-card strong { color: #e3ece6; }\n[data-theme=\"dark\"] .shipping-choice-card span { color: #9fb0a6; }\n[data-theme=\"dark\"] .shipping-choice-card.selected { border-color: #e3ece6; box-shadow: 0 0 0 2px #e3ece6 inset; }\n[data-theme=\"dark\"] .shipping-wizard .group button.shipping-preset-option { border-color: #3a463e; background: #1c2620; color: #e3ece6; }\n[data-theme=\"dark\"] .shipping-wizard .group button.shipping-preset-option:hover { background: #222f28; color: #cfe3d6; }\n[data-theme=\"dark\"] .shipping-wizard .group button.shipping-preset-option span { color: #9fb0a6; }\n[data-theme=\"dark\"] .shipping-wizard .group button.shipping-preset-option.selected { border-color: #e3ece6; box-shadow: 0 0 0 1px #e3ece6 inset; }\n[data-theme=\"dark\"] .shipping-fieldset { border-color: #3a463e; }\n[data-theme=\"dark\"] .shipping-fieldset legend { color: #cfe3d6; }\n[data-theme=\"dark\"] .shipping-wizard .group button.shipping-chip { border-color: #3a463e; background: #1c2620; color: #e3ece6; }\n[data-theme=\"dark\"] .shipping-wizard .group button.shipping-chip:hover { background: #222f28; color: #cfe3d6; }\n[data-theme=\"dark\"] .shipping-summary dt { color: #cfe3d6; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
